import React from 'react';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.30645 0.604852L1.35355 0.646447L4 3.2925L6.64645 0.646447C6.84171 0.451185 7.15829 0.451185 7.35355 0.646447C7.5338 0.826689 7.54766 1.1103 7.39515 1.30645L7.35355 1.35355L4.7075 4L7.35355 6.64645C7.54882 6.84171 7.54882 7.15829 7.35355 7.35355C7.17331 7.5338 6.8897 7.54766 6.69355 7.39515L6.64645 7.35355L4 4.7075L1.35355 7.35355C1.15829 7.54882 0.841709 7.54882 0.646447 7.35355C0.466205 7.17331 0.45234 6.8897 0.604852 6.69355L0.646447 6.64645L3.2925 4L0.646447 1.35355C0.451185 1.15829 0.451185 0.841709 0.646447 0.646447C0.826689 0.466205 1.1103 0.45234 1.30645 0.604852Z"
        fill="white"
      />
    </Svg>
  );
};

export default Icon;
